import {Fragment} from 'react'

import {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import MoleculeAccordion, {moleculeAccordionBehavior, MoleculeAccordionItem} from '@s-ui/react-molecule-accordion'
import IconAccordionCollapsed from '@adv-mt/mt-svg-icons/lib/ChevronDown.js'
import IconAccordionExpanded from '@adv-mt/mt-svg-icons/lib/ChevronUp.js'

import {useLandingInstantOfferTracking} from '../../../../../useLandingInstantOfferTracking.js'
import {faqQuestions, faqTracking} from './config.js'

const BASE_CLASS_NAME = 'mt-Landing-InstantOffer-Faqs'

const LandingInstantOfferFaqs = () => {
  const {trackFaqExpanded} = useLandingInstantOfferTracking()

  const onToggleFaqsTab = (event, {value, isExpanded}) => {
    if (isExpanded) {
      trackFaqExpanded({question: faqTracking[value]})
    }
  }

  return (
    <div className={BASE_CLASS_NAME}>
      <h2 className={`${BASE_CLASS_NAME}Title`}>{`¿Tienes dudas? Te ayudamos`}</h2>
      <p className={`${BASE_CLASS_NAME}Description`}>
        {`Tenlo todo bajo control en el momento de vender tu vehículo al profesional.`}
      </p>
      <MoleculeAccordion
        as={Fragment}
        headerIconCollapsed={<IconAccordionCollapsed size={ATOM_ICON_SIZES.medium} />}
        headerIconExpanded={<IconAccordionExpanded size={ATOM_ICON_SIZES.medium} />}
        behavior={moleculeAccordionBehavior.MULTIPLE}
        onChange={onToggleFaqsTab}
      >
        <div className={`${BASE_CLASS_NAME}Accordion`}>
          {Object.keys(faqQuestions).map((faqKey, index) => (
            <MoleculeAccordionItem
              as="div"
              content={<p className={`${BASE_CLASS_NAME}AccordionText`}>{faqQuestions[faqKey].answer}</p>}
              headerAs="h3"
              key={faqKey}
              label={faqQuestions[faqKey].question}
              value={index}
            />
          ))}
        </div>
      </MoleculeAccordion>
    </div>
  )
}

LandingInstantOfferFaqs.displayName = 'LandingInstantOfferFaqs'

export default LandingInstantOfferFaqs
